import {
  GridCellProps,
  GridCustomFilterCellProps,
} from '@progress/kendo-react-grid';
import { ApiEnums } from '../../Interfaces/ApiEnums';
import {
  alertTextToTypeMap,
  alertTypeNameMap,
  getAlertTextArray,
} from '../../utils/textMappings';
import { AlertTypeDropDownFilterCell } from './AlertTypeDropDownFilterCell';
import { GetString } from '../StringResourceManager';

export const AlertTypeCell = (props: GridCellProps) => {
  const dataItem = props.dataItem;
  return (
    <td style={{ fontSize: '0.9rem' }}>
      {GetString(alertTypeNameMap(dataItem.AlertType as ApiEnums.AlertType))}
    </td>
  );
};

export const AlertTypeFilterCell: any = (props: GridCustomFilterCellProps) => (
  <AlertTypeDropDownFilterCell
    {...props}
    data={getAlertTextArray()}
    defaultItem={GetString('SELECT_TYPE')}
    onChangeValueCheckFunc={alertTextToTypeMap}
  />
);
